import { render, staticRenderFns } from "./home-view.vue?vue&type=template&id=fa4e8f42&scoped=true"
import script from "./home-view.vue?vue&type=script&lang=js"
export * from "./home-view.vue?vue&type=script&lang=js"
import style0 from "./home-view.vue?vue&type=style&index=0&id=fa4e8f42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa4e8f42",
  null
  
)

export default component.exports